"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ActionButtonsBar = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ActionItem = require("./ActionItem");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const ActionButtonsBar = _ref => {
  let {
    actionItems,
    containerType = 'column'
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "actionButtons ".concat(containerType !== null && containerType !== void 0 ? containerType : '')
  }, actionItems.map(item => /*#__PURE__*/_react.default.createElement(_ActionItem.ActionItem, _extends({
    key: item.id
  }, item, {
    onClick: item === null || item === void 0 ? void 0 : item.onClick,
    showSpinner: item.showSpinner
  }))));
};
exports.ActionButtonsBar = ActionButtonsBar;
ActionButtonsBar.propTypes = {
  actionItems: _propTypes.default.arrayOf(_propTypes.default.shape(_ActionItem.ActionItem.propTypes)),
  containerType: _propTypes.default.string
};
var _default = exports.default = ActionButtonsBar;